export const VALIDATION_LOADING_TEXT = 'Running validations';